import React from 'react';
import { Box, Inscription, Preloader, RoundPendingIcon } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';

interface Props {
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UnlockCardConfirmDialog: React.FC<Props> = ({ isLoading, onCancel, onConfirm }) => (
  <Box direction="column" align="center" data-testid="unlock-card-confirm-dialog">
    <Box align="center" justify="center" width="72px" height="72px">
      <RoundPendingIcon size="48px" color="warning" />
    </Box>
    <Inscription
      size="2xl"
      color="textTitle"
      weight="bold"
      lineHeight="32px"
      margin={{ top: 'spacing16', bottom: 'l' }}
    >
      Unlock card?
    </Inscription>
    <Box direction="row" align="center" justify="center" gap="xs">
      <AppButton
        buttonType="secondary"
        width="140px"
        type="button"
        testId="unlock-card-confirm-dialog_cancel-button"
        onClick={onCancel}
      >
        Cancel
      </AppButton>
      <AppButton
        disabled={isLoading}
        type="button"
        color="blue"
        width="140px"
        testId="unlock-card-confirm-dialog_confirm-button"
        onClick={onConfirm}
      >
        {isLoading ? <Preloader color="white" /> : 'Unlock'}
      </AppButton>
    </Box>
  </Box>
);

export default UnlockCardConfirmDialog;
